import { InjectionToken } from '@angular/core';
import { EnvConfig } from '@sbd-doug-frontend/app/environments/envconfig';

export const ENVIRONMENT_INJECTION_TOKEN = new InjectionToken<EnvConfig>('Environment Config');
